// Product Main JavaScript
// Extracted from main-product.liquid for better organization

// Fonction pour afficher/masquer le formulaire de gravure
function toggleEngravingForm() {
  const form = document.getElementById('engraving-form');
  if (form.style.display === 'none') {
    form.style.display = 'block';
  } else {
    form.style.display = 'none';
  }
}

// Auto-play des vidéos produit
document.addEventListener('DOMContentLoaded', function() {
  // Forcer l'autoplay des vidéos dans la galerie produit
  const productVideos = document.querySelectorAll('.product__media-list video');
  productVideos.forEach(video => {
    video.muted = true;
    video.loop = true;
    video.autoplay = true;
    video.controls = false;
    video.playsInline = true;
    
    // Forcer le démarrage si nécessaire
    video.play().catch(e => {
      // Autoplay prevented
    });
  });

  // Gérer les vidéos dans les sections image-with-text (inspiration de la collection)
  const imageWithTextVideos = document.querySelectorAll('.image-text-media-mobile video, .image-text-media-desktop video');
  imageWithTextVideos.forEach(video => {
    video.muted = true;
    video.loop = true;
    video.autoplay = true;
    video.controls = false;
    video.playsInline = true;
    
    // Forcer le démarrage si nécessaire
    video.play().catch(e => {
      // Autoplay prevented
    });
  });

  // Gérer les vidéos dans deferred-media - FORCER LE CHARGEMENT AUTOMATIQUE
  const deferredMediaElements = document.querySelectorAll('.product__media-list deferred-media');
  deferredMediaElements.forEach(deferredMedia => {
    // Masquer le bouton de lecture
    const posterButton = deferredMedia.querySelector('.deferred-media__poster');
    if (posterButton) {
      posterButton.style.display = 'none';
    }
    
    // Masquer l'interface de lecture (icône et boutons)
    const modalOpener = deferredMedia.parentElement.querySelector('.product__modal-opener--video');
    if (modalOpener) {
      modalOpener.style.display = 'none';
    }
    
    // Masquer l'image de prévisualisation
    const previewImage = deferredMedia.parentElement.querySelector('.product__media img');
    if (previewImage) {
      previewImage.style.display = 'none';
    }
    
    // Charger automatiquement le contenu immédiatement pour les vidéos
    const template = deferredMedia.querySelector('template');
    if (template && !deferredMedia.hasAttribute('loaded')) {
      const content = template.content.cloneNode(true);
      const video = content.querySelector('video');
      const iframe = content.querySelector('iframe');
      
      if (video) {
        video.muted = true;
        video.loop = true;
        video.autoplay = true;
        video.controls = false;
        video.playsInline = true;
        video.style.pointerEvents = 'none';
        video.style.userSelect = 'none';
        video.style.webkitUserSelect = 'none';
        video.style.mozUserSelect = 'none';
        video.style.msUserSelect = 'none';
        video.style.position = 'absolute';
        video.style.top = '0';
        video.style.left = '0';
        video.style.width = '100%';
        video.style.height = '100%';
        video.style.objectFit = 'contain';
        video.style.objectPosition = 'top';
        video.style.zIndex = '1';
        video.style.display = 'block';
        video.style.visibility = 'visible';
      }
      
      if (iframe) {
        iframe.style.pointerEvents = 'none';
      }
      
      deferredMedia.appendChild(content);
      deferredMedia.setAttribute('loaded', '');
      
      // Démarrer la vidéo immédiatement
      setTimeout(() => {
        const loadedVideo = deferredMedia.querySelector('video');
        if (loadedVideo) {
          // S'assurer que la vidéo est visible
          loadedVideo.style.display = 'block';
          loadedVideo.style.visibility = 'visible';
          loadedVideo.style.opacity = '1';
          
          // Démarrer la vidéo
          loadedVideo.play().catch(e => {
            // Autoplay prevented
            // Réessayer après un délai
            setTimeout(() => {
              loadedVideo.play().catch(e2 => {
                // Retry autoplay failed
              });
            }, 1000);
          });
        }
      }, 50);
    }
  });
  
  // Réessayer l'autoplay après un délai pour s'assurer que tout est chargé
  setTimeout(() => {
    const allVideos = document.querySelectorAll('.product__media-list video, .image-text-media-mobile video, .image-text-media-desktop video');
    allVideos.forEach(video => {
      if (video.paused) {
        video.play().catch(e => {
          // Retry autoplay failed
        });
      }
    });
  }, 1000);

  // Gestion spécifique pour les vidéos image-with-text avec un délai plus long
  setTimeout(() => {
    const imageWithTextVideos = document.querySelectorAll('.image-text-media-mobile video, .image-text-media-desktop video');
    imageWithTextVideos.forEach(video => {
      if (video.paused) {
        video.muted = true;
        video.loop = true;
        video.autoplay = true;
        video.controls = false;
        video.playsInline = true;
        video.play().catch(e => {
          // Image-with-text video retry autoplay failed
        });
      }
    });

    // Gérer les iframes YouTube/Vimeo dans image-with-text
    const imageWithTextIframes = document.querySelectorAll('.image-text-media-mobile iframe, .image-text-media-desktop iframe');
    imageWithTextIframes.forEach(iframe => {
      const src = iframe.src;
      if (src.includes('youtube.com') || src.includes('vimeo.com')) {
        // Forcer le rechargement avec autoplay si ce n'est pas déjà fait
        if (!src.includes('autoplay=1')) {
          const separator = src.includes('?') ? '&' : '?';
          iframe.src = src + separator + 'autoplay=1&mute=1';
        }
      }
    });
  }, 2000);

  // Observer les changements dans le DOM pour les nouvelles sections image-with-text
  const imageWithTextObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        const addedNodes = Array.from(mutation.addedNodes);
        const hasImageWithText = addedNodes.some(node => 
          node.nodeType === 1 && (
            node.classList?.contains('image-with-text') || 
            node.querySelector?.('.image-with-text')
          )
        );
        
        if (hasImageWithText) {
          // Nouvelle section image-with-text détectée, initialisation des vidéos
          setTimeout(() => {
            const newVideos = document.querySelectorAll('.image-text-media-mobile video, .image-text-media-desktop video');
            newVideos.forEach(video => {
              video.muted = true;
              video.loop = true;
              video.autoplay = true;
              video.controls = false;
              video.playsInline = true;
              video.play().catch(e => {
                // Nouvelle vidéo image-with-text autoplay failed
              });
            });
          }, 500);
        }
      }
    });
  });
  
  imageWithTextObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Appeler la fonction d'initialisation globale
  initializeProductPageFeatures();

  // Diagnostic après chargement complet
  setTimeout(() => {
    diagnoseMobileIssues();
  }, 3000);
  
  // Gestion des dots du slider
  const sliderDots = document.querySelectorAll('.slider-dot');
  const sliderViewer = document.querySelector('[id^="GalleryViewer"]');
  
  if (sliderDots.length > 0 && sliderViewer) {
    // Mettre à jour les dots quand le slide change
    sliderViewer.addEventListener('slideChanged', (event) => {
      const currentSlide = event.detail.currentElement;
      if (!currentSlide || !currentSlide.parentElement) {
        return;
      }
      const slideIndex = Array.from(currentSlide.parentElement.children).indexOf(currentSlide) + 1;
      
      // Mettre à jour les dots
      sliderDots.forEach((dot, index) => {
        dot.classList.toggle('active', index + 1 === slideIndex);
      });
    });
    
    // Gérer les clics sur les dots
    sliderDots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const slideIndex = index + 1;
        const slides = sliderViewer.querySelectorAll('.slider__slide');
        const targetSlide = slides[slideIndex - 1];
        
        if (targetSlide) {
          // Déclencher le changement de slide
          const slideChangedEvent = new CustomEvent('slideChanged', {
            detail: { currentElement: targetSlide }
          });
          sliderViewer.dispatchEvent(slideChangedEvent);
          
          // Faire défiler vers le slide
          targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });
  }
});

// Compteur de caractères pour la gravure
document.addEventListener('DOMContentLoaded', function() {
  // Ne pas exécuter dans l'interface d'administration Shopify
  if (window.location.hostname.includes('myshopify.com') && 
      (window.location.pathname.includes('/admin') || 
       window.location.pathname.includes('/themes') ||
       window.location.pathname.includes('/customize'))) {
    return;
  }
  
  const engravingInput = document.getElementById('engraving-input');
  const engravingCounter = document.getElementById('engraving-counter');
  
  if (engravingInput && engravingCounter) {
    // Détecter la langue
    const isEnglish = window.location.pathname.includes('/en/') || window.location.pathname.includes('/en-') || window.location.pathname === '/en';
    const charactersText = isEnglish ? 'characters' : 'caractères';
    const maxChars = parseInt(engravingInput.getAttribute('maxlength')) || 8;
    // Max chars pour gravure
    
    engravingInput.addEventListener('input', function() {
      const currentLength = this.value.length;
      engravingCounter.innerHTML = `<span id="char-count">${currentLength}</span>/${maxChars} ${charactersText}`;
      
      // Synchroniser avec le champ caché dans le formulaire principal
      const hiddenInput = document.querySelector('input[name="properties[Gravure]"]');
      if (hiddenInput && hiddenInput !== this) {
        hiddenInput.value = this.value;
      }
    });
    
    // Animation à l'ouverture du formulaire - optimisée pour éviter les reflows
    engravingInput.addEventListener('focus', function() {
      this.parentElement.style.transform = 'scale(1.02)';
      this.parentElement.style.willChange = 'transform';
    });
    
    engravingInput.addEventListener('blur', function() {
      this.parentElement.style.transform = 'scale(1)';
      this.parentElement.style.willChange = 'auto';
    });
  }

  // Créer un input caché dans le formulaire principal pour la gravure
  const mainForm = document.querySelector('form[action*="/cart/add"]');
  if (mainForm && !mainForm.querySelector('input[name="properties[Gravure]"]')) {
    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = 'properties[Gravure]';
    hiddenInput.value = '';
    hiddenInput.id = 'hidden-gravure-input';
    mainForm.appendChild(hiddenInput);
    // Input caché créé
  } else if (mainForm) {
    // Input caché existe déjà
  } else {
    // Formulaire principal non trouvé
  }
  
  // Synchroniser la gravure avec l'input caché
  const engravingField = document.getElementById('engraving-input');
  if (engravingField) {
    engravingField.addEventListener('input', function() {
      const hiddenInput = document.getElementById('hidden-gravure-input');
      if (hiddenInput) {
        hiddenInput.value = this.value;
        // Gravure synchronisée
      } else {
        // Input caché non trouvé
      }
    });
    
    // Synchroniser aussi au moment de la soumission
    engravingField.addEventListener('blur', function() {
      const hiddenInput = document.getElementById('hidden-gravure-input');
      if (hiddenInput) {
        hiddenInput.value = this.value;
        // Gravure synchronisée au blur
      }
    });
  } else {
    // Champ de gravure non trouvé
  }
  
  // Debug au moment de la soumission du formulaire
  if (mainForm) {
    mainForm.addEventListener('submit', function(e) {
      // Synchroniser la gravure juste avant la soumission
      const engravingField = document.getElementById('engraving-input');
      const hiddenInput = document.getElementById('hidden-gravure-input');
      
      if (engravingField && hiddenInput) {
        hiddenInput.value = engravingField.value;
        // Synchronisation forcée avant soumission
      }
      
      if (hiddenInput && hiddenInput.value) {
        // Soumission avec gravure
      } else {
        // Soumission sans gravure
      }
    });
  }
  
  // Intercepter directement le custom element product-form
  const productForm = document.querySelector('product-form');
  if (productForm) {
    const originalOnSubmit = productForm.onSubmitHandler;
    if (originalOnSubmit) {
      productForm.onSubmitHandler = function(evt) {
        // Product-form onSubmitHandler intercepté
        
        // Forcer la synchronisation avant l'envoi
        const engravingField = document.getElementById('engraving-input');
        const hiddenInput = document.getElementById('hidden-gravure-input');
        if (engravingField && hiddenInput) {
          hiddenInput.value = engravingField.value;
          // Synchronisation forcée
        }
        
        return originalOnSubmit.call(this, evt);
      };
    }
  }
  
  // Intercepter la création du FormData
  const originalFormData = window.FormData;
  window.FormData = function(...args) {
    const formData = new originalFormData(...args);
    
    // Ajouter la gravure si elle existe
    const engravingField = document.getElementById('engraving-input');
    if (engravingField && engravingField.value) {
      formData.set('properties[Gravure]', engravingField.value);
      // Gravure ajoutée au FormData
    }
    
    return formData;
  };

  // Fermer la modale avec la touche Échap
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      const modal = document.getElementById('ring-sizer-modal');
      if (modal) {
        closeRingSizerModal();
      }
      const bookingModal = document.getElementById('booking-widget-modal');
      if (bookingModal) {
        closeBookingWidget();
      }
    }
  });
});

// Fonction pour ouvrir le widget de réservation
function openBookingWidget(blockId) {
  // Ouverture widget de réservation pour bloc
  
  // Récupérer les données configurables
  const dataElement = document.getElementById('booking-widget-data-' + blockId);
  // Element de données trouvé
  
  if (!dataElement) {
    // Données du widget non trouvées
    return;
  }
  
  const customScript = dataElement.getAttribute('data-custom-script');
  const fallbackWidgetId = dataElement.getAttribute('data-widget-id') || 'sbw_gjxk8a';
  
  // Supprimer la modale existante si elle existe
  const existingModal = document.getElementById('booking-widget-modal');
  if (existingModal) {
    existingModal.remove();
  }
  
  // Si un script personnalisé est fourni, l'utiliser
  if (customScript && customScript.trim() !== '') {
    // Utilisation du script personnalisé SimplyBook.me
    executeCustomScript(customScript, blockId);
  } else {
    // Utilisation du script par défaut
    // Utiliser le script par défaut
    const config = {
      widget_id: fallbackWidgetId
    };
    
    // Créer la modale avec le widget
    const modal = document.createElement('div');
    modal.id = 'booking-widget-modal';
    modal.innerHTML = `
      <div style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.7); z-index: 99999; display: flex; align-items: center; justify-content: center; padding: 20px;">
        <div style="background: white; width: 90%; max-width: 800px; max-height: 80vh; position: relative; box-shadow: 0 4px 20px rgba(0,0,0,0.3); border-radius: 8px; overflow: hidden;">
          <button onclick="closeBookingWidget()" style="position: absolute; top: 15px; right: 15px; background: none; border: none; font-size: 24px; cursor: pointer; color: #666; padding: 0; width: 30px; height: 30px; z-index: 100000;">&times;</button>
          
          <div id="${config.widget_id}_modal" style="width: 100%; height: 70vh; min-height: 500px;"></div>
        </div>
      </div>
    `;
    
    // Ajouter la modale au body
    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';
    
    // Charger le script SimplyBook.me par défaut
    if (!window.SimplybookWidget) {
      const script = document.createElement('script');
      script.async = true;
      script.src = "//widget.simplybook.it/v2/widget/widget.js";
      script.onload = function() {
        initBookingWidget(config);
      };
      document.head.appendChild(script);
    } else {
      initBookingWidget(config);
    }
  }
}

// Fonction pour exécuter le script personnalisé
function executeCustomScript(scriptContent, blockId) {
  try {
    // Extraire le container_id du script pour créer la modale appropriée
    const containerIdMatch = scriptContent.match(/"container_id":"([^"]+)"/);
    const containerId = containerIdMatch ? containerIdMatch[1] : 'sbw_gjxk8a';
    
    // Créer la modale avec l'ID correct
    const modal = document.createElement('div');
    modal.id = 'booking-widget-modal';
    modal.innerHTML = `
      <div style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.7); z-index: 99999; display: flex; align-items: center; justify-content: center; padding: 20px;">
        <div style="background: white; width: 90%; max-width: 800px; max-height: 80vh; position: relative; box-shadow: 0 4px 20px rgba(0,0,0,0.3); border-radius: 8px; overflow: hidden;">
          <button onclick="closeBookingWidget()" style="position: absolute; top: 15px; right: 15px; background: none; border: none; font-size: 24px; cursor: pointer; color: #666; padding: 0; width: 30px; height: 30px; z-index: 100000;">&times;</button>
          
          <div id="${containerId}" style="width: 100%; height: 70vh; min-height: 500px;"></div>
        </div>
      </div>
    `;
    
    // Ajouter la modale au body
    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';
    
    // Modifier le script pour utiliser le widget_type "iframe" au lieu de "button"
    let modifiedScript = scriptContent.replace(/"widget_type":"button"/, '"widget_type":"iframe"');
    
    // Supprimer les balises script du contenu
    modifiedScript = modifiedScript.replace(/<script[^>]*>/gi, '').replace(/<\/script>/gi, '');
    
    // Exécuter le script modifié
    eval(modifiedScript);
    
    // Script personnalisé exécuté avec succès
  } catch (error) {
    // Erreur lors de l'exécution du script personnalisé
    // En cas d'erreur, fermer la modale et utiliser le fallback
    closeBookingWidget();
    alert('Erreur dans le script SimplyBook.me. Veuillez vérifier la configuration.');
  }
}

// Fonction pour initialiser le widget (fallback)
function initBookingWidget(config) {
  new SimplybookWidget({
    "widget_type": "iframe",
    "url": "https://loyaleparis.simplybook.it",
    "theme": "concise",
    "timeline": "modern",
    "datepicker": "top_calendar",
    "is_rtl": false,
    "app_config": {
      "clear_session": 0,
      "allow_switch_to_ada": 0,
      "predefined": []
    },
    "container_id": config.widget_id + "_modal"
  });
}

// Fonction pour fermer le widget de réservation
function closeBookingWidget() {
  const modal = document.getElementById('booking-widget-modal');
  if (modal) {
    modal.remove();
    document.body.style.overflow = 'auto';
    // Widget de réservation fermé
  }
}

// Fonction d'initialisation globale pour les vidéos et sliders
function initializeProductPageFeatures() {
  // Initialisation des fonctionnalités de la page produit
  
  // Réinitialiser les vidéos image-with-text
  const imageWithTextVideos = document.querySelectorAll('.image-text-media-mobile video, .image-text-media-desktop video');
  imageWithTextVideos.forEach(video => {
    if (video.paused) {
      video.muted = true;
      video.loop = true;
      video.autoplay = true;
      video.controls = false;
      video.playsInline = true;
      video.play().catch(e => {
        // Réinitialisation vidéo image-with-text failed
      });
    }
  });

  // Réinitialiser les iframes
  const imageWithTextIframes = document.querySelectorAll('.image-text-media-mobile iframe, .image-text-media-desktop iframe');
  imageWithTextIframes.forEach(iframe => {
    const src = iframe.src;
    if (src.includes('youtube.com') || src.includes('vimeo.com')) {
      if (!src.includes('autoplay=1')) {
        const separator = src.includes('?') ? '&' : '?';
        iframe.src = src + separator + 'autoplay=1&mute=1';
      }
    }
  });
}

// Fonction de diagnostic pour les problèmes mobile
function diagnoseMobileIssues() {
  // Diagnostic des problèmes mobile
  
  // Vérifier les vidéos image-with-text
  const imageWithTextVideos = document.querySelectorAll('.image-text-media-mobile video, .image-text-media-desktop video');
  // Vidéos image-with-text trouvées
  imageWithTextVideos.forEach((video, index) => {
    // Vidéo diagnostic
  });

  // Vérifier les iframes
  const imageWithTextIframes = document.querySelectorAll('.image-text-media-mobile iframe, .image-text-media-desktop iframe');
  // Iframes image-with-text trouvées
  imageWithTextIframes.forEach((iframe, index) => {
    // Iframe diagnostic
  });

  // Vérifier le slider related-products
  const relatedSliders = document.querySelectorAll('.related-slider-mobile');
  // Sliders related-products trouvés
  relatedSliders.forEach((slider, index) => {
    const slides = slider.querySelectorAll('.related-slide');
    const arrows = slider.querySelectorAll('.related-slider-mobile-arrow');
    const dots = slider.querySelectorAll('.related-slider-dot');
    // Slider diagnostic
  });
}

// Exposer les fonctions globalement
window.toggleEngravingForm = toggleEngravingForm;
window.openBookingWidget = openBookingWidget;
window.closeBookingWidget = closeBookingWidget;
window.initializeProductPageFeatures = initializeProductPageFeatures;
window.diagnoseMobileIssues = diagnoseMobileIssues;
